<script>
	import { cookies } from '@tools';
</script>

<svelte:head>
	<script
		async
		id="CookieConsent"
		src="https://policy.app.cookieinformation.com/uc.js"
		data-culture="da"
		type="text/javascript"
	></script>

	<!--
		Facebook Pixel Code head tag
	-->
	<script>
		!(function (f, b, e, v, n, t, s) {
			if (f.fbq) return;
			n = f.fbq = function () {
				n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
			};
			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = !0;
			n.version = '2.0';
			n.queue = [];
			t = b.createElement(e);
			t.async = !0;
			t.src = v;
			s = b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t, s);
		})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
		fbq('consent', 'revoke');
		fbq('init', '1337715936288061');
		fbq('track', 'PageView');
	</script>

	{#if cookies.consents.get('marketing')}
		<!--
			YouTube head tag
		-->
		<script async src="https://www.youtube.com/iframe_api"></script>

		<!--
			Google Tag Manager head tag
		-->
		<script type="text/javascript">
			(function (w, d, s, l, i) {
				w[l] = w[l] || [];
				w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
				var f = d.getElementsByTagName(s)[0],
					j = d.createElement(s),
					dl = l != 'dataLayer' ? '&l=' + l : '';
				j.async = true;
				j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
				f.parentNode.insertBefore(j, f);
			})(window, document, 'script', 'dataLayer', 'GTM-5NV9MT9');
		</script>

		<!--
			HeyAnalytics head tag
		-->
		<script type="text/javascript">
			var hlt;
			var BiTrackingLoaded = function (BiTracking) {
				hlt = BiTracking;
				// console.log('BiTrackingLoaded');

				// BiTracking.createCookie = function (name, uid, days) {
				// 	console.log('customCreateCookie');
				// 	if (days) {
				// 		var date = new Date();
				// 		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				// 		var expires = '; expires=' + date.toGMTString();
				// 	} else {
				// 		var expires = '';
				// 	}
				// 	document.cookie =
				// 		name + '=' + uid + expires + '; path=/; SameSite=Lax; Secure; domain=.musikhuset.dk;';
				// };

				BiTracking.initialize('2uEiBJZhVQO98it6', 45, '10550');
			};
		</script>
		<script type="text/javascript">
			(function (d, t) {
				var g = d.createElement(t),
					s = d.getElementsByTagName(t)[0];
				h = 'https:' == document.location.protocol ? 'https://' : 'http://';
				// g.src = h + 'bi.heyloyalty.com/hlbi.js';
				g.src = h + 'www.musikhuset.dk/hlbi-crossdomain.js';
				s.parentNode.insertBefore(g, s);
			})(document, 'script');
		</script>
	{/if}
</svelte:head>

{#if cookies.consents.get('marketing')}
	<!--
			Google Tag Manager (noscript) body tag
		-->
	<noscript>
		<iframe
			title="Google Tag Manager"
			src="https://www.googletagmanager.com/ns.html?id=GTM-5NV9MT9"
			height="0"
			width="0"
			style="display:none;visibility:hidden"
		></iframe>
	</noscript>

	<!--
			Piwik body tag
		-->
	<script type="text/javascript">
		(function (window, document, dataLayerName, id) {
			(window[dataLayerName] = window[dataLayerName] || []),
				window[dataLayerName].push({ start: new Date().getTime(), event: 'stg.start' });
			var scripts = document.getElementsByTagName('script')[0],
				tags = document.createElement('script');
			function stgCreateCookie(a, b, c) {
				var d = '';
				if (c) {
					var e = new Date();
					e.setTime(e.getTime() + 24 * c * 60 * 60 * 1e3), (d = '; expires=' + e.toUTCString());
					f = '; SameSite=Strict';
				}
				document.cookie = a + '=' + b + d + f + '; path=/';
			}
			var isStgDebug =
				(window.location.href.match('stg_debug') || document.cookie.match('stg_debug')) &&
				!window.location.href.match('stg_disable_debug');
			stgCreateCookie('stg_debug', isStgDebug ? 1 : '', isStgDebug ? 14 : -1);
			var qP = [];
			dataLayerName !== 'dataLayer' && qP.push('data_layer_name=' + dataLayerName),
				isStgDebug && qP.push('stg_debug');
			var qPString = qP.length > 0 ? '?' + qP.join('&') : '';
			(tags.async = !0),
				(tags.src = 'https://musikhuset.containers.piwik.pro/' + id + '.js' + qPString),
				scripts.parentNode.insertBefore(tags, scripts);
			!(function (a, n, i) {
				a[n] = a[n] || {};
				for (var c = 0; c < i.length; c++)
					!(function (i) {
						(a[n][i] = a[n][i] || {}),
							(a[n][i].api =
								a[n][i].api ||
								function () {
									var a = [].slice.call(arguments, 0);
									'string' == typeof a[0] &&
										window[dataLayerName].push({
											event: n + '.' + i + ':' + a[0],
											parameters: [].slice.call(arguments, 1)
										});
								});
					})(i[c]);
			})(window, 'ppms', ['tm', 'cm']);
		})(window, document, 'dataLayer', '5f0f2e9b-fa85-4343-a8db-7551c3704f2c');
	</script>
{/if}
